// Este codigo fue generado por Github Copilot Chat
import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-step-by-step',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './step-by-step.component.html',
  styleUrls: ['./step-by-step.component.scss']
})
export class StepByStepComponent {
  @Input() currentStep = 1;
  @Input() stepList!: string[];
}
// Este codigo fue generado por Github Copilot Chat
